
import MapboxDraw from '@mapbox/mapbox-gl-draw';

let drawAdded = false;
let draw = "";
let curclickCallBackFunc = "";
let curUpdateCallBackFunc = "";
let mapM = "";

let handleCanvasClick = e => {
  e.stopPropagation();/*阻止事件冒泡,保证重复检查的功能独占鼠标点击事件*/
}

let getDraw = () => {
  addDraw();
  return draw;
}

let handleEsc = e =>{
  /*如果点击了esc,则移除canvas的监听事件*/
  if (e.keyCode == 27) {
    unbindEvent(true);
  }
}

let unbindEvent = () => {
  if(mapM){mapM.getCanvas().style.cursor='';}
  document.removeEventListener('keyup',handleEsc);
  setTimeout(() => {
    mapM.getCanvas().removeEventListener('click',handleCanvasClick);
  },200);
}

let handleClickCallBack = (e) => {
  unbindEvent();
  if(curclickCallBackFunc){
    curclickCallBackFunc(e);
    curclickCallBackFunc = "";
  }
}

let handleUpdatekCallBack = (e) => {
  unbindEvent();
  if(curUpdateCallBackFunc){
    curUpdateCallBackFunc(e);
    curUpdateCallBackFunc = "";
  }
}

let addDraw = () => {
  if(!drawAdded){
    draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {}
    });
    mapM.addControl(draw);
    drawAdded = true;
  }
};

let measure = (map,type,clickCallBackFunc = "",updateCallBackFunc = "") => {
  if(!map){ console.error("请传入地图实例"); return; }
  mapM = map;
  map.getCanvas().style.cursor='crosshair';
  addDraw();
  if(clickCallBackFunc){
    curclickCallBackFunc = clickCallBackFunc;
    mapM.on('draw.create',handleClickCallBack);
  }

  if(updateCallBackFunc){
    curUpdateCallBackFunc = updateCallBackFunc;
    mapM.on('draw.update',handleUpdatekCallBack);
  }
  mapM.getCanvas().addEventListener('click', handleCanvasClick);
  document.addEventListener('keyup',handleEsc);
  draw.changeMode(type);
}

let clear = () => {
  if(draw){
    draw.deleteAll();
  }
}


export default {
  measure:measure,
  clear:clear,
  getDraw:getDraw,
  unbindEvent:unbindEvent
}



// WEBPACK FOOTER //
// ./src/components/mapElementBox/toolbar/measureComponent/measureComponent.js